import { render, staticRenderFns } from "./DocumentUpdate.vue?vue&type=template&id=288ed4e4&scoped=true&"
import script from "./DocumentUpdate.vue?vue&type=script&lang=js&"
export * from "./DocumentUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288ed4e4",
  null
  
)

export default component.exports